import React from 'react';
import PropTypes from 'prop-types';

import {
  groupBy,
  keys,
  map,
  sortBy,
  toLower
} from '../../../../util/lodashlike';
import { Progress, Table } from 'antd';
import classnames from 'classnames';
import style from './index.scss';
import { SingleDataColumn } from '../../../common/components';
import { FRAUD_PREVENTION_SOURCE_IDS } from '../../../constants/commonConstants';

const configToColumns = (config, dataMapping) => {
  const preventionAlertColors = (key, typlogyActions) => {
    return typlogyActions?.find(
      ({ displayName }) => toLower(displayName) === toLower(key)
    )?.alertLevelColor;
  };

  return map(groupBy(config.widgetConfig, 'columnName'), (v, k) => {
    const children = v.filter((col) => {
      return col.columnVisibility;
    });
    return {
      columnName: k,
      columnIndex: Math.min(...map(v, (i) => i.columnIndex)),
      colSpan: children.length,
      children: children
    };
  })
    .filter((col) => col.children.length > 0)
    .sort((a, b) => a.columnIndex - b.columnIndex)
    .map((col) => {
      return {
        title: col.columnName,
        key: col.columnName,
        colSpan: col.colSpan,
        children: sortBy(col.children, ['columnIndex']).map((item) => {
          return {
            title: item.columnDetail.map((i) => {
              return <div key={i.itemName}>{i.itemLabel}</div>;
            }),
            key: item.columnDetail.map((i) => i.itemName).join('-'),
            render: (value, row) => {
              return item.columnDetail.map((i) => {
                if (i.itemName === 'rules') {
                  return (
                    <div className={style.ellipsisBlock}>
                      <SingleDataColumn.Ellipsis pop value={row[i.itemName]} />
                    </div>
                  );
                } else if (i.itemName === 'alertLevel') {
                  if (
                    FRAUD_PREVENTION_SOURCE_IDS.includes(
                      parseInt(row[`alertSourceId`])
                    )
                  ) {
                    const fraudInfo = row[`additionalFraudInfo`];
                    const fraudActions = row[`fraudActions`];

                    return keys(fraudInfo)?.map((key) => (
                      <div
                        key={key}
                        style={{
                          color: preventionAlertColors(key, fraudActions)
                        }}>
                        {`${key}: ${fraudInfo[key]}`}
                      </div>
                    ));
                  } else {
                    return <div>{row[i.itemName]}</div>;
                  }
                } else if (i.itemName === 'alertScore') {
                  if (row['alertScore']) {
                    return (
                      <div
                        className="alert-score-container"
                        key={i.itemName}
                        title={row?.detailedAlertScore}>
                        <span>{row['alertScore']}</span>
                        <Progress
                          percent={row['alertScore']}
                          showInfo={false}
                          size="small"
                          strokeColor={row['alertLevelColor']}
                        />
                      </div>
                    );
                  } else {
                    return '';
                  }
                }

                return (
                  <div key={i.itemName}>
                    {dataMapping[i.itemName]
                      ? dataMapping[i.itemName](row)
                      : i.itemName in row &&
                        row[i.itemName] &&
                        row[i.itemName] !== 'null'
                      ? row[i.itemName].toString()
                      : '-'}
                  </div>
                );
              });
            }
          };
        })
      };
    });
};

const CRSDataTable = ({
  GSConfig = {},
  data = [],
  loadMore,
  hasMore,
  loading,
  rowKey = 'id',
  dataMapping = {},
  pagination
}) => {
  const columns = configToColumns(GSConfig, dataMapping);
  return (
    <Table
      bordered
      className={classnames(style.table)}
      columns={columns}
      dataSource={data}
      pagination={pagination ? pagination : false}
      footer={
        hasMore
          ? () => (
              <div className={style.loadMore}>
                <a onClick={loadMore}>Load more</a>
              </div>
            )
          : null
      }
      loading={loading}
      rowKey={rowKey}
    />
  );
};

CRSDataTable.propTypes = {
  GSConfig: PropTypes.object,
  data: PropTypes.array,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  rowKey: PropTypes.string,
  dataMapping: PropTypes.object
};

export default CRSDataTable;
